import React, { Fragment } from "react";
import styled from "styled-components";
import {
  TableCell, TableHead, TableBody,
  Table, TableRow, TableFooter
} from "@material-ui/core";
import EnhancedTableHead from "components/Global/Table/EnhancedTableHead";
import BuildColumns from "components/Global/TablePreferenceColumns/BuildColumns";
import { NoItems } from "components/Deal/DealDetailsSections/util";
import { default as PropertiesTableColumns } from "components/Global/TablePreferenceColumns/PropertiesTableColumns/PropertiesTableColumns";

const EmptyPropertiesDiv = styled.div`
  && {
    margin-top: 17px,
    margin-bottom: 17px
  }
`;
const NoHoverTableRow = styled(TableRow)`
  /* Work Sans / 12 Semibold CAPS */
  font-family: Work Sans;
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 24px;

  /* Text / Dark Gray */
  color: #5F6368;
  &&:hover {    
    background-color: #FFFFFF !important;
  }
`;

const StyledTable = styled.div`&&&{
  border: 1px solid #DADCE0;
  border-radius: 8px 8px 8px 8px !important;
}`;

const EmptyProperties = () => (
  <EmptyPropertiesDiv>
    <NoItems Message={"No Properties available"} />
  </EmptyPropertiesDiv>
);

const PropertiesList = props => {
  const { records, orderDirection, orderBy, handleRequestSort } = props;
  const columns = PropertiesTableColumns();

  // create rows
  const getRows = () => records.map(record => (
    // row for each record
    <NoHoverTableRow key={record.propertyId} hover>
      {/* column for each record */}
      {columns.map(({ id, Cell }) => (
        <Cell
          key={id}
          data={record}
          style={{ fontFamily: "Work Sans",
            fontStyle: "normal",
            fontWeight: "600",
            fontSize: "99px",
            lineHeight: "14px",
            color: "#5F6368" }}
        />
      ))}
    </NoHoverTableRow>
  ));

  return (
    <>
      {records && records.length > 0 ?
        (
          <StyledTable>
            <Table className="loansList_Table">
              <EnhancedTableHead
                order={orderDirection}
                orderBy={orderBy}
                onRequestSort={handleRequestSort}
                columns={columns}
                shouldHideConfig
                shouldHideExport
              />
              <TableBody>
                {getRows()}
              </TableBody>
            </Table>
          </StyledTable>
        ) : (
          <EmptyProperties />
        )}
    </>
  );
};

export default PropertiesList;
